import React, { useRef } from "react";
import HeroSection from "./components/HeroSection";
import AboutSection from "./components/AboutSection";
import VenturesSection from "./components/VenturesSection";
import IndustriesSection from "./components/IndustriesSection";
import AchievementsSection from "./components/AchievementsSection";
import VisionSection from "./components/VisionSection";
import ContactSection from "./components/ContactSection";
import SealSection from "./components/SealSection";

function App() {
  const venturesRef = useRef(null);
  const contactRef = useRef(null);

  const scrollToSection = (ref) => {
    if (ref.current) {
      ref.current.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <div className="text-gray-800">
      <HeroSection
        scrollToVentures={() => scrollToSection(venturesRef)}
        scrollToContact={() => scrollToSection(contactRef)}
      />
      <AboutSection />
      <VenturesSection ref={venturesRef} />
      <IndustriesSection />
      <AchievementsSection />
      <VisionSection />
      <SealSection />
      <ContactSection ref={contactRef} />
    </div>
  );
}

export default App;
